export const DESKTOP_FEED_STANDARD = 'DESKTOP_FEED_STANDARD';
export const MOBILE_FEED_STANDARD = 'MOBILE_FEED_STANDARD';
export const FACEBOOK_STORY_MOBILE = 'FACEBOOK_STORY_MOBILE';
export const INSTAGRAM_STANDARD = 'INSTAGRAM_STANDARD';
export const INSTAGRAM_STORY = 'INSTAGRAM_STORY';
